import { PrivateBetaScreen } from './PrivateBetaScreen';

export const UserManagement = () => {
  return (
    <PrivateBetaScreen
      icon="i-bolt:user-management"
      title="Your userbase at a glance"
      description="View user sign-ups over time and easily access individual user details."
    />
  );
};
